'use strict';

const gtm = require('../../modules/google').tagManager;

module.exports = {
    computed: {
        customerSelectedContainer() {
            return this.$store.getters.customerSelectedContainer;
        },
        customerSelectedFiller() {
            return this.$store.getters.customerSelectedFiller;
        },
        productCollection() {
            return this.$store.getters.productData.collection;
        },
        productSelection() {
            return [this.customerSelectedContainer, this.customerSelectedFiller]
                .filter(Boolean)
                .map((part) => part.name)
                .join('/');
        }
    },
    methods: {
        handleStepInteraction(stepCtaName) {
            if (!stepCtaName) {
                return;
            }

            /* eslint-disable camelcase */
            const event = {
                event: 'configurator',
                sublevel_1: 'in-page',
                sublevel_2: this.productCollection,
                click_target: stepCtaName
            };
            /* eslint-enable camelcase */
            if (this.customerSelectedFiller) {
                event['content_group'] = this.customerSelectedFiller.categoryName;
            }
            if (this.productSelection) {
                event.selection = this.productSelection;
            }

            gtm.pushDataLayerEvent(event);
        }
    }
};
